var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowLeftIcon = function SvgArrowLeftIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6446 12.652C11.5678 12.9046 11.573 13.175 11.6594 13.4244C11.6926 13.5205 11.7625 13.6458 11.9531 13.8618C12.1495 14.0844 12.426 14.3513 12.8384 14.7482L16.6466 18.4131C16.9451 18.7004 16.9542 19.1751 16.667 19.4736C16.3797 19.7721 15.905 19.7812 15.6065 19.4939L11.7983 15.829L11.7764 15.8079C11.3915 15.4375 11.0702 15.1283 10.8284 14.8543C10.5762 14.5685 10.3658 14.2729 10.2419 13.9152C10.0519 13.3664 10.0405 12.7716 10.2094 12.2159C10.3194 11.8537 10.5184 11.5502 10.7594 11.255C10.9906 10.9719 11.2997 10.6507 11.6701 10.2658L11.6912 10.2439L15.3562 6.43567C15.6434 6.13722 16.1182 6.12812 16.4166 6.41534C16.7151 6.70257 16.7242 7.17735 16.437 7.47581L12.772 11.284C12.3751 11.6965 12.1091 11.9737 11.9213 12.2037C11.7391 12.4268 11.6741 12.5548 11.6446 12.652Z",
    fill: "#22272F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowLeftIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-left-icon.3eae536f.svg";
export { ForwardRef as ReactComponent };